import { render, staticRenderFns } from "./SetupTab.vue?vue&type=template&id=83083aae&scoped=true"
import script from "./SetupTab.vue?vue&type=script&lang=js"
export * from "./SetupTab.vue?vue&type=script&lang=js"
import style0 from "./SetupTab.vue?vue&type=style&index=0&id=83083aae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83083aae",
  null
  
)

export default component.exports